import { createContext, useContext } from 'react';
import { Cart, CartDetails } from '@/modules/store/models/Cart';
import { CartItem } from '@/modules/store/models/CartItem';
import { DeliveryWindow } from '@/modules/store/models/DeliveryWindow';
import { PickupWindow } from '@/modules/store/models/PickupWindow';
import { Supplier } from '@/modules/store/models/Supplier';

export interface CartContextProps {
  getCarts: (suppliers?: Supplier[]) => Cart[];
  getSelectedCartsAndItems: () => Cart[];
  removeSelectedCartsAndItems: () => void;
  cartItemCount: number;
  addedSkuIds: string[];
  currentSkuIds: string[];
  addToCart: (
    supplierId: string,
    item: CartItem | CartItem[],
    deliveryWindow?: DeliveryWindow,
    pickupWindow?: PickupWindow,
  ) => void;
  updateItemFromCart: (supplierId: string, itemId: number, quantity: number) => void;
  removeItemFromCart: (supplierId: string, itemId: number) => void;
  updateDeliveryWindow: (supplierId: string, deliveryWindow: DeliveryWindow | null) => void;
  updateSelectedCartItems: (items: number[], supplierId: string) => void;
  resetCart: () => void;
  canCheckout: (carts: CartDetails[]) => boolean;
  isInitialized: boolean;
}

const CartContext = createContext<CartContextProps | undefined>(undefined);

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};

export default CartContext;
